import { TrashIcon } from '@heroicons/react/24/solid'
import { ContactPerson } from '../../../types/ContactPerson'
import Upsert from './Upsert'
import RemoveConfirmation from '../RemoveConfirmation/RemoveConfirmation'

type Props = {
  data: ContactPerson
  invert?: boolean
  removeCallback: () => void
  updateCallback: (person: ContactPerson) => void
}

const Person: React.FC<Props> = ({ data, invert = false, removeCallback, updateCallback }) => {
  const getName = () => `${data.firstname || ''} ${data.lastname || ''}`
  return (
    <div className="flex flex-row items-center justify-between">
      <div className={`truncate ${invert ? 'text-white' : ''}`}>{getName()}</div>
      <div className="flex flex-row gap-2 items-center">
        <Upsert invert={invert} initData={data} callback={updateCallback} />
        <RemoveConfirmation itemName={getName()} confirmationCallback={removeCallback}>
          <TrashIcon className="fill-white w-5 cursor-pointer" />
        </RemoveConfirmation>
      </div>
    </div>
  )
}

export default Person
